import React from 'react';
import { Navigate } from 'react-router-dom';

function isAuthenticated() {
  return Boolean(sessionStorage.getItem('wp_token'));
}

export default function AuthGuard({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/auth/login" replace />;
  }
  return children;
}
